import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { DeviceStatusEnum } from '@gtpl/shared-models/masters';
export class DeviceUpdateDto {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Device Mac Id should not be empty" })
    deviceMacId: string;

    @ApiProperty({
        enum: DeviceStatusEnum,
        default: DeviceStatusEnum.ONLINE
    })
    @IsNotEmpty({ message: "Device Type should not be empty" })
    @IsEnum(DeviceStatusEnum)
    deviceStatus: DeviceStatusEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Last Reported Time should not be empty" })
    lastReportedTime: Date;

    @ApiProperty()
    @IsNotEmpty({ message: "Device Error Message should not be empty" })
    deviceErrorMsg: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;
}